export default __webpack_public_path__ + "static/media/wangusa.a641007c.png";